import TemplateView from "../../TemplateView";
import {HIERARCHY_LEVEL_CLASSES} from "./constants";

export default class CounterProgressBar extends TemplateView {
    constructor({
        hierarchyLevel = "",
    }) {
        super();
        this.props = {
            hierarchyLevel,
        }
        this.state = {
            ratio: 0
        };
        this.onStateChanged(() => this._updateProgress());
    }

    _updateProgress() {
        this.$barValue.css({
            'width': Math.round(this.state.ratio * 100) + '%'
        });
    }

    templateHtml() {
        return "<div class='components_cptProgressBar <%-hierarchyLevelClass%>'>" +
               "   <div class='border'></div>" +
               "   <div class='value'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            hierarchyLevelClass: HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
        }
    }

    afterRender() {
        this.$barValue = this.find('.value');
    }
}



// WEBPACK FOOTER //
// ./web/js/components/counterCPT/CounterProgressBar.js